import { render, staticRenderFns } from "./LeadBoxCompleted.vue?vue&type=template&id=3d38a6a0&scoped=true&"
import script from "./LeadBoxCompleted.vue?vue&type=script&lang=js&"
export * from "./LeadBoxCompleted.vue?vue&type=script&lang=js&"
import style0 from "./LeadBoxCompleted.vue?vue&type=style&index=0&id=3d38a6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38a6a0",
  null
  
)

export default component.exports